import * as React from "react";
import { useState } from "react";
import { MoneyDisplayHelper } from "../../../../../../../../react-core/Helpers/MoneyDisplayHelper";
import { Lightbox, LightboxType } from "../../../../../../../../react-core/Html/Components/Lightbox";
import { JsonDateParser } from "../../../../../../../../react-core/Utils/JsonDateParser";
import { CurrencyCode } from "../../../../../../../../Wrap/Constants/Enums/Domain/CurrencyCode";
import { SubAccountType } from "../../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { UserClaim } from "../../../../../../../../Wrap/Constants/Enums/UserClaim";
import { TransactionPaymentsWithdrawalsColumns } from "../../../../../../../../Wrap/Models/Domains/Users/UserPageColumnSetting/TransactionPaymentsWithdrawalsColumns";
import { PaymentStatus } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Investment/PaymentStatus";
import { RegularDepositMethod } from '../../../../../../../../Wrap/Constants/Enums/Domain/RegularDepositMethod';
import { CashPayment } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPayment";
import { CashPaymentFrequencyQuery } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/CashPaymentFrequencyQuery";
import { InstructionType } from "../../../../../../../../Wrap/Models/Models/PortfolioAnalysis/Payment/InstructionType";
import { Alert } from "../../../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../../../Shared/Entities/Constants/AlertConstants";
import { ProcessType } from "../../../../../../../Shared/IST/Resource/Content";
import { Permission } from "../../../../../../../Shared/Permission/Permission";
import { checkPermission } from "../../../../../../../Shared/Permission/PermissionHelper";
import { ITableConfig, Table } from "../../../../../../../Shared/Table/Table";
import { TableColSettingKeys } from "../../../../../../../Shared/TableColFilter/Resource/Content";
import { TableColEditor } from "../../../../../../../Shared/TableColFilter/TableColEditor";
import AriaTooltip from "../../../../../../../Shared/Tooltip/AriaTooltip";
import { Typography } from "../../../../../../../Shared/Typography/Typography";
import { Methods } from "../../../../../../Common/CommonHelper";
import { StaticUrls } from "../../../../../../Resoures/StaticUrls";
import { subAccountTypeMap } from "../../Performance/Resource/Contents";
import { regularDepositMethodArraysMap } from "../../../../Common/Resource/Contents";
import { WizardLinkRestriction } from "../../../../Common/Restrictions/WizardLinkRestriction";
import { PortfolioDashboardStore } from "../../../Store/Variable";
import { getSubAccountInfoByClAccountId } from "../../Common/PortfolioDashboardHelper";
import { Contents, PaymentSourceMap, paymentStatusMap } from "../Resource/Contents";
import { InvestorType } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/InvestorType";
import { SubAccountTypeHelper } from "../../../../Common/Helpers/SubAccountTypeHelper";

interface IPaymentsWithdrawalsProps {
    data: CashPayment[];
    selectAccount: string;
    frequency: CashPaymentFrequencyQuery;
    bondPayments: Array<any>;
    onTableChange: () => void;
    subAccountTypeSelected?: SubAccountType;
}

export const PaymentsWithdrawals = (props: IPaymentsWithdrawalsProps) => {
    const [showErrorMsg, setShowErrorMsg] = useState<boolean>(false);

    const getMoneyFormat = (val: number): string => {
        let formatMoney = MoneyDisplayHelper.FromatMoneyDisplay(Math.abs(val), CurrencyCode.GBP);
        if (val < 0) {
            formatMoney = "-" + formatMoney;
        }
        return formatMoney;
    };
    const getPercentageFormat = (val: number): string => {
        return val.toFixed(2) + "%";
    };

    const getWithdrawalTitle = (type: SubAccountType): string => {
        let title = "Withdrawals";
        if (type == SubAccountType.OnshoreBond) {
            title = "Onshore Bond Withdrawals";
        }
        if (type == SubAccountType.OffshoreBond) {
            title = "Offshore Bond Withdrawals";
        }

        return title;
    };

    const actionLink = (data: CashPayment, clAccountId: string) => {
        const { headAccount, subAccount } = getSubAccountInfoByClAccountId(
            data?.AccountNumber,
            PortfolioDashboardStore.getData()
        );
        const accountHierarchy = subAccount?.HierarchyId ?? headAccount?.HierarchyId;

        let isDlu = false;
        if (headAccount?.InvestorType == InvestorType.Trust) {
            isDlu = true;
        } else if (
            SubAccountTypeHelper.isBond(subAccount?.SubAccountType) ||
            SubAccountTypeHelper.isSIPP(subAccount?.SubAccountType)
        ) {
            isDlu = true;
        }

        const isBlockWithdrwal = WizardLinkRestriction(headAccount, accountHierarchy, ProcessType.Withdrawal);
        const isBlockTopUp = WizardLinkRestriction(headAccount, accountHierarchy, ProcessType.SinglePayment);
        return (
            <span>
                {data.Type.toLowerCase() == "deposit" &&
                    checkPermission(UserClaim.AdviserPortalDluCashEntryMatchDetailCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={`/popups/CashEntryMatchDetail.aspx?cashid=${data.Id}&claccountid=${props.selectAccount}`}
                            >
                                Match History
                            </a>
                            <br />
                        </>
                    )}

                {data.InstructionType == InstructionType.Standing &&
                    checkPermission(UserClaim.AdviserPortalDluCashEntryDetailCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={`/popups/CashEntryDetail.aspx?cashid=${data.Id}&claccountid=${props.selectAccount}&standingHistory=true`}
                            >
                                H
                            </a>
                            <br />{" "}
                        </>
                    )}

                {(data.InstructionType == InstructionType.RegularWithdrawal ||
                    data.InstructionType == InstructionType.OneOffWithdrawal) &&
                    data.Narration &&
                    checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={`/Clients/Cash/RegularWithdrawals.aspx?actiontype=summary&claccountid=${clAccountId}&RegularWithdrawalID=${data.Id}`}
                            >
                                Summary
                            </a>{" "}
                            <br />
                        </>
                    )}

                {(data.InstructionType == InstructionType.RegularWithdrawal ||
                    data.InstructionType == InstructionType.OneOffWithdrawal) &&
                    !data.Narration &&
                    checkPermission(UserClaim.AdviserPortalDluRegularWithdrawalHoldingsCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={`/popups/RegularWithdrawalHoldings.aspx?RegularWithdrawalID=${data.Id}`}
                            >
                                Holdings
                            </a>
                        </>
                    )}

                {data.InstructionType == InstructionType.RegularWithdrawal &&
                    (data.Status == PaymentStatus.Authorised || data.Status == PaymentStatus.Confirmed) &&
                    !data.IsWrapHubTransfer &&
                    checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={
                                    isBlockWithdrwal
                                        ? "javascript:void(0);"
                                        : `/clients/cash/RegularWithdrawals.aspx?&claccountid=${clAccountId}&regularwithdrawalid=${data.Id}&actiontype=edit`
                                }
                                onClick={() => {
                                    if (isBlockWithdrwal) {
                                        setShowErrorMsg(true);
                                    }
                                }}
                            >
                                Edit
                            </a>
                            <br />
                        </>
                    )}

                {data.InstructionType == InstructionType.Standing &&
                    data.Type.toLocaleLowerCase() == "transfer" &&
                    data.Status != PaymentStatus.Completed &&
                    data.Status != PaymentStatus.Cancelled &&
                    !data.IsWrapHubTransfer &&
                    checkPermission(UserClaim.AdviserPortalDluCashDepositCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={
                                    isBlockTopUp
                                        ? "javascript:void(0);"
                                        : StaticUrls.DepositUrl(
                                            clAccountId,
                                            "edit",
                                            data.Id.toString(),
                                            "transfer",
                                            null,
                                            "true"
                                        )
                                }
                                onClick={() => {
                                    if (isBlockTopUp) {
                                        setShowErrorMsg(true);
                                    }
                                }}
                            >
                                Edit
                            </a>
                            <br />
                        </>
                    )}

                {data.InstructionType == InstructionType.Standing &&
                    data.Type.toLocaleLowerCase() == "deposit" &&
                    data.Status != PaymentStatus.Completed &&
                    data.Status != PaymentStatus.Cancelled &&
                    !data.IsWrapHubTransfer &&
                    checkPermission(UserClaim.AdviserPortalSPTAndRegularPaymentReadWrite) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                onClick={() => {
                                    const url = isDlu
                                        ? StaticUrls.NBEC(
                                            subAccount?.ClAccountId,
                                            SubAccountTypeHelper.isLegacyProduct(subAccount?.SubAccountType)
                                        )
                                        : StaticUrls.RegularPaymentUrl(
                                            subAccount.SubAccountType.toString(),
                                            subAccount.ClAccountId,
                                            headAccount.HierarchyId,
                                            subAccount.HierarchyId,
                                            "edit",
                                            data.BatchId
                                        );
                                    if (isBlockTopUp) {
                                        setShowErrorMsg(true);
                                    } else {
                                        window.open(url, "_blank");
                                    }
                                }}
                            >
                                Edit
                            </a>
                            <br />
                        </>
                    )}
                {data.InstructionType === InstructionType.OneOff &&
                    data.Type?.toLocaleLowerCase() !== "withdrawal" &&
                    data.Status != PaymentStatus.Completed &&
                    data.Status != PaymentStatus.Cancelled &&
                    (data.Method != RegularDepositMethod.DirectDebit || data.Status != PaymentStatus.Placed) &&
                    !data.IsWrapHubTransfer &&
                    checkPermission(UserClaim.AdviserPortalDluCashDepositCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={
                                    isBlockTopUp
                                        ? "javascript:void(0);"
                                        : data.Type.toLocaleLowerCase() == "transfer"
                                            ? StaticUrls.DepositUrl(
                                                clAccountId,
                                                "edit",
                                                data.Id.toString(),
                                                "transfer",
                                                Number(data.InstructionType).toString(),
                                                "true"
                                            )
                                            : StaticUrls.DepositUrl(
                                                clAccountId,
                                                "edit",
                                                data.Id.toString(),
                                                null,
                                                Number(data.InstructionType).toString(),
                                                "true"
                                            )
                                }
                                onClick={() => {
                                    if (isBlockTopUp) {
                                        setShowErrorMsg(true);
                                    }
                                }}
                            >
                                Edit
                            </a>
                            <br />
                        </>
                    )}

                {(data.InstructionType == InstructionType.RegularWithdrawal ||
                    data.InstructionType == InstructionType.OneOffWithdrawal) &&
                    data.Status != PaymentStatus.Cancelled &&
                    data.Status != PaymentStatus.InProgress &&
                    data.Status != PaymentStatus.Completed &&
                    checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={`/clients/cash/RegularWithdrawals.aspx?claccountid=${clAccountId}&regularwithdrawalid=${data.Id}&actiontype=setupcancel`}
                            >
                                Cancel
                            </a>
                            <br />
                        </>
                    )}

                {data.InstructionType != InstructionType.RegularWithdrawal &&
                    data.Type?.toLocaleLowerCase() !== "withdrawal" &&
                    data.InstructionType != InstructionType.OneOffWithdrawal &&
                    data.Status != PaymentStatus.Cancelled &&
                    data.Status != PaymentStatus.InProgress &&
                    data.Status != PaymentStatus.Completed &&
                    data.Status != PaymentStatus.Confirmed &&
                    !data.IsWrapHubTransfer &&
                    (data.BacsStatus == null ||
                        (data.BacsStatus.toLocaleLowerCase() != "posted" &&
                            data.BacsStatus.toLocaleLowerCase() != "journalled" &&
                            data.BacsStatus.toLocaleLowerCase() != "loaded")) &&
                    checkPermission(UserClaim.AdviserPortalDluCashDepositCanView) && (
                        <>
                            <a
                                className="hyperlink"
                                target="_blank"
                                href={StaticUrls.DepositUrl(
                                    clAccountId,
                                    "cancel",
                                    data.Id.toString(),
                                    "transfer",
                                    null,
                                    null
                                )}
                            >
                                Cancel
                            </a>
                            <br />
                        </>
                    )}
            </span>
        );
    };

    const idLink = (data: CashPayment, clAccountId: string) => {
        return (
            <span>
                {data.InstructionType == InstructionType.RegularWithdrawal ||
                    data.InstructionType == InstructionType.OneOffWithdrawal ? (
                    <Permission
                        userClaim={UserClaim.AdviserPortalDluRegularWithdrawalHistoryCanView}
                        replaceChildren={<a href={"javascript:void(0);"}> {data.Id}</a>}
                    >
                        <a
                            className="hyperlink"
                            target="_blank"
                            href={`/popups/RegularWithdrawalHistory.aspx?RegularWithdrawalID=${data.Id}`}
                        >
                            {data.Id}
                        </a>
                    </Permission>
                ) : (
                    <Permission
                        userClaim={UserClaim.AdviserPortalDluCashEntryDetailCanView}
                        replaceChildren={<a href={"javascript:void(0);"}> {data.Id}</a>}
                    >
                        <a
                            className="hyperlink"
                            target="_blank"
                            href={`/popups/CashEntryDetail.aspx?cashid=${data.Id}&claccountid=${clAccountId}`}
                        >
                            {data.Id}
                        </a>
                    </Permission>
                )}
            </span>
        );
    };

    const getTooltipContent = (val: CashPayment) => {
        if (val.InstructionType !== InstructionType.RegularWithdrawal && val.InstructionType !== InstructionType.Standing) {
            return [
                {
                    title: "Account number",
                    data: val.BankAccountNumber ? val.BankAccountNumber : "N/A",
                },
                { title: "Sort code", data: val.SortCode ? val.SortCode : "N/A" },
                { title: "IBAN", data: val.IBAN ? val.IBAN : "N/A" },
                { title: "SWIFT/BIC", data: val.BIC ? val.BIC : "N/A" },
                { title: "Next payment date", data: "N/A" },
                { title: "Payer type", data: val.Owner ? val.Owner : PaymentSourceMap[val.Source] },
            ];
        } else {
            return [
                {
                    title: "Account number",
                    data: val.BankAccountNumber ? val.BankAccountNumber : "N/A",
                },
                { title: "Sort code", data: val.SortCode ? val.SortCode : "N/A" },
                { title: "IBAN", data: val.IBAN ? val.IBAN : "N/A" },
                { title: "SWIFT/BIC", data: val.BIC ? val.BIC : "N/A" },
                { title: "First payment date", data: JsonDateParser.getFormatDate(val.FirstDate, "dd/MM/yyyy") },
                { title: "Next payment date", data: JsonDateParser.getFormatDate(val.NextDate, "dd/MM/yyyy") },
                { title: "Payer type", data: val.Owner ? val.Owner : PaymentSourceMap[val.Source] },
            ];
        }
    };

    const tableColConfig: ITableConfig[] = [
        {
            title: "Type",
            key: "Type",
            tableFilter: TransactionPaymentsWithdrawalsColumns.Type,
            filterOption: { disableEdit: true },
        },
        {
            title: "Products",
            key: "ProductType",
            tableFilter: TransactionPaymentsWithdrawalsColumns.Products,
            render: (data, row, index) => {
                return subAccountTypeMap[data];
            },
            filterOption: { disableEdit: true },
        },
        {
            title: "Frequency",
            key: "Frequency",
            tableFilter: TransactionPaymentsWithdrawalsColumns.Frequency,
            render: (data, row, index) => {
                if (
                    row.InstructionType == InstructionType.RegularWithdrawal ||
                    row.InstructionType == InstructionType.OneOffWithdrawal ||
                    row.InstructionType == InstructionType.Standing
                ) {
                    return Methods.getFormatFrequencyType(data);
                } else {
                    return "N/A";
                }
            },
            filterOption: { disableEdit: true },
        },
        {
            title: "Method",
            key: "Method",
            filterOption: { disableEdit: true },
            render: (data, row, index) => {
                return regularDepositMethodArraysMap[data];
            },
            tableFilter: TransactionPaymentsWithdrawalsColumns.Method,
        },
        {
            title: "Date created",
            key: "DateCreated",
            tableFilter: TransactionPaymentsWithdrawalsColumns.DateCreated,
            render: (data, row, index) => {
                return JsonDateParser.getFormatDate(data, "dd/MM/yyyy");
            },
            filterOption: { disableEdit: true },
        },
        {
            title: "Amount",
            key: "Amount",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            tableFilter: TransactionPaymentsWithdrawalsColumns.Amount,
            filterOption: { disableEdit: true },
            render: (data, row, index) => {
                return (
                    <span>
                        <AriaTooltip
                            cssWrapper="is-underlined-text no-border-radius"
                            buttonText={data > 0 ? getMoneyFormat(data) : getPercentageFormat(row.Percentage)}
                            trigger="hover"
                            title={false}
                        >
                            <Typography type="auto-width" wrapCss="mt-10 mb-0" config={getTooltipContent(row)} />
                        </AriaTooltip>
                    </span>
                );
            },
        },
        {
            title: "Instruction",
            key: "Instruction",
            filterOption: { disableEdit: true },
            tableFilter: TransactionPaymentsWithdrawalsColumns.Instruction,
        },
        {
            title: "Status",
            key: "Status",
            tableFilter: TransactionPaymentsWithdrawalsColumns.Status,
            render: (data, row, index) => paymentStatusMap[data],
            filterOption: { disableEdit: true },
        },
        {
            title: "Contribution ID#",
            key: "ContributionGroup",
            tableFilter: TransactionPaymentsWithdrawalsColumns.ContributionID,
        },
        {
            title: "Entry ID#",
            key: "Id",
            thCssWrapper: "cell-right",
            tdCssWrapper: "cell-right",
            userClaim: UserClaim.AdviserPortalPaymentsAndWithdrawlsColumnCashEntryIdCanView,
            tableFilter: TransactionPaymentsWithdrawalsColumns.EntryID,
            render: (data, row, index) => {
                return idLink(row, props.selectAccount);
            },
        },
        { title: "Plan manager", key: "PlanManager", tableFilter: TransactionPaymentsWithdrawalsColumns.PlannManager },
        {
            title: "Unique ID",
            key: "BatchId",
            tableFilter: TransactionPaymentsWithdrawalsColumns.UniqueID,
            render: (data, row, index) => {
                return row.BatchId > 0 ? row.BatchId : "";
            },
        },
        {
            title: "Actions",
            key: "",
            userClaim: UserClaim.AdviserPortalPaymentsAndWithdrawlsColumnActionsCanView,
            tableFilter: TransactionPaymentsWithdrawalsColumns.Actions,
            render: (data, row, index) => {
                return actionLink(row, props.selectAccount);
            },
        },
        { title: "Narration", key: "Narration", tableFilter: TransactionPaymentsWithdrawalsColumns.Narration },
    ];

    return (
        <div>
            <div className="row row-right wide-gutter mb-10">
                <div className="col-auto col-middle">
                    <TableColEditor
                        col={tableColConfig}
                        tableEditorKey={TableColSettingKeys.TransactionPaymentsWithdrawals}
                        title="Table editor"
                    />
                </div>
            </div>
            {props.data?.length == 0 && props.bondPayments?.length == 0 && (
                <Alert alertType={AlertType.Warning} message={"No cash entries have been raised for this account."} />
            )}
            {showErrorMsg && (
                <Lightbox
                    show={showErrorMsg}
                    title={"Warning"}
                    contentAfterTitle={null}
                    onClose={() => setShowErrorMsg(false)}
                    type={LightboxType.Modal}
                    cssWrapper={"is-default-lightbox"}
                >
                    <p>You cannot process this action until the account is active</p>
                    <button className="btn primary" onClick={() => setShowErrorMsg(false)}>
                        Ok
                    </button>
                </Lightbox>
            )}
            {props.data?.length > 0 && (
                <Table
                    data={props.data}
                    col={tableColConfig}
                    colEditorKey={TableColSettingKeys.TransactionPaymentsWithdrawals}
                />
            )}
            {props.bondPayments.length > 0 && (
                <h3 className="mb-0">{getWithdrawalTitle(props.subAccountTypeSelected)}</h3>
            )}

            <div>
                <div>
                    {props.bondPayments.length > 0 && (
                        <Table
                            cssWrapper="table-subtle"
                            data={props.bondPayments}
                            col={[
                                {
                                    title: "Withdrawal Type",
                                    key: "RegularPaymentType",
                                    render: (data, row) => {
                                        return Methods.getWithdrawalPaymentType(data);
                                    },
                                },
                                {
                                    title: "Withdrawal Annual Amount",
                                    key: "AnnualAmount",
                                    render: (data, row) =>
                                        MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2),
                                },
                                {
                                    title: "Payment Frequency",
                                    key: "Frequency",
                                    render: (data, row) => {
                                        return Methods.getFormatFrequencyType(data);
                                    },
                                },
                                {
                                    title: "Withdrawal Payment per Frequency",
                                    key: "Amount",
                                    render: (data, row) =>
                                        MoneyDisplayHelper.FromatMoneyDisplay(data, CurrencyCode.GBP, true, 2),
                                },
                                {
                                    title: "First Withdrawal Date",
                                    key: "FirstDate",
                                },
                                {
                                    title: "Next Withdrawal Date",
                                    key: "NextDate",
                                },

                                {
                                    title: "Stop Date/Last Payment date",
                                    key: "FinalDate",
                                    render: (data, row) => {
                                        return Methods.getStopDate(
                                            row.CurrentStatus,
                                            data == Contents.InvalidateDate ? "-" : data
                                        );
                                    },
                                },
                                {
                                    title: "Withdrawal Status",
                                    key: "CurrentStatus",
                                    render: (data, row) => {
                                        return Methods.getWithdrawalStatus(data);
                                    },
                                },
                                {
                                    title: "Payment Method",
                                    key: "PaymentMethod",
                                    render: (data, row) => {
                                        return Methods.getPaymentMethod(data);
                                    },
                                },
                                {
                                    title: "Account Name",
                                    key: "AccountName",
                                },
                                {
                                    title: "Account Number",
                                    key: "BankAccountNumber",
                                },
                                {
                                    title: "Account Sortcode",
                                    key: "BankIdentifier",
                                },
                            ]}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};
